import type { Hit, SearchResponse } from 'algoliasearch';

export interface AlgoliaResult {
    content: string;
    depth: number;
    description: string;
    hostname: string;
    keywords: string;
    objectID: string;
    part: number;
    path: string;
    title: string;
    type: string;
    url: string;
    image: string;
}

export interface PredictiveRedirectRules {
    shopRedirectUrl: string;
}

export const DEFAULT_PREDICTIVE_REDIRECT_RULES: PredictiveRedirectRules = {
    shopRedirectUrl: 'https://shop.siriusxm.com/',
};

const SHOP_RESULT_DESCRIPTION = 'Shop SiriusXM - Save more with exclusive offers on radios for your home and car.';

function createShopResult(query: string, redirectUrl: string): Hit<AlgoliaResult> {
    return {
        content: '',
        depth: 0,
        description: SHOP_RESULT_DESCRIPTION,
        hostname: redirectUrl,
        keywords: query,
        objectID: '',
        part: 0,
        path: redirectUrl,
        title: 'Shop SiriusXM',
        type: '',
        url: redirectUrl,
        image: '',
    };
}

export function buildPredictiveResults(
    searchIndex: SearchResponse<AlgoliaResult>,
    query: string,
    redirectRules: PredictiveRedirectRules = DEFAULT_PREDICTIVE_REDIRECT_RULES,
): Hit<AlgoliaResult>[] {
    const hits = [...searchIndex.hits];

    const redirectUrl = searchIndex.renderingContent?.redirect?.url;

    if (redirectUrl === redirectRules.shopRedirectUrl) {
        hits.unshift(createShopResult(query, redirectUrl));
    }

    return hits;
}
